/**
 * Human-readable titles
 */export const TITLES={// no_title translates to an empty string in select fields
doc:'Dr.',professor:'Prof.'};Object.freeze(TITLES);/**
 * Options for Dropdown (select element)
 */export const TITLE_OPTIONS=Object.entries(TITLES).map(_ref=>{let[key,value]=_ref;return{key,value};});Object.freeze(TITLE_OPTIONS);